/**
 * 사용자 아바타 컴포넌트 (사이드바용)
 * 실제 사용자 정보를 로드하여 표시
 */

import { useState, useEffect } from "react"
import MDAvatar from "components/MDAvatar"
import { request } from "app/network"
import { UserProfile } from "app/types/UserProfile"

interface UserAvatarProps {
    size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl"
}

function UserAvatar({ size = "sm" }: UserAvatarProps): JSX.Element {
    const [userFirstLetter, setUserFirstLetter] = useState("U")
    const [userImageUrl, setUserImageUrl] = useState<string | null>(null)

    useEffect(() => {
        loadUserInfo()
    }, [])

    const loadUserInfo = async () => {
        try {
            // 토큰이 없으면 API 호출하지 않음 (로그인 화면 등)
            const token = localStorage.getItem("token")
            if (!token) return

            const response = await request("User.getCurrentUser", { paramz: {} })

            if (response.status === 200 && response.data) {
                const userData: UserProfile = response.data
                const displayName = userData.name || userData.nickname || userData.id
                const firstLetter = displayName ? displayName.charAt(0).toUpperCase() : "U"

                setUserFirstLetter(firstLetter)
                setUserImageUrl(userData.profileImageUrl || null)
            }
        } catch (error) {
            console.error("사용자 정보 로드 실패:", error)
        }
    }

    return (
        <MDAvatar
            src={userImageUrl}
            alt="User"
            size={size}
            bgColor={userImageUrl ? "transparent" : "info"}
        >
            {!userImageUrl && userFirstLetter}
        </MDAvatar>
    )
}

export default UserAvatar
